import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button, Form } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
// import { reactLocalStorage } from 'reactjs-localstorage';

import { Col, Row, Container } from 'react-bootstrap'
import { formatDate } from '../utils/functions';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const EditPrescription = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const [startDate, setStartDate] = useState(new Date());
    var location = useLocation();
    // console.log(location)
    const { state } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState()
    const [loading, setLoading] = useState(false)
    const [storeCustomers, setStoreCustomers] = useState([])


    const [pData, setPData] = useState({
        // st_id: state.storeData[0].st_id,
        id: location.state.id,
        patient_id: location?.state?.cust_id ? location.state.cust_id : '',
        prescriber: location?.state?.prescriber ? location.state.prescriber : '',
        prescription_date: location?.state?.prescription_date ? location.state.prescription_date : '',
        h_phone: location?.state?.h_phone ? location.state.h_phone : '',
        o_phone: location?.state?.o_phone ? location.state.o_phone : '',
        odsph: location?.state?.odsph ? location.state.odsph : '',
        odcyl: location?.state?.odcyl ? location.state.odcyl : '',
        odaxis: location?.state?.odaxis ? location.state.odaxis : '',
        odprism: location?.state?.odprism ? location.state.odprism : '',
        odfi: location?.state?.odfi ? location.state.odfi : '',
        odct: location?.state?.odct ? location.state.odct : '',
        ossph: location?.state?.ossph ? location.state.ossph : '',
        oscyl: location?.state?.oscyl ? location.state.oscyl : '',
        osaxis: location?.state?.osaxis ? location.state.osaxis : '',
        osprism: location?.state?.osprism ? location.state.osprism : '',
        osfi: location?.state?.osfi ? location.state.osfi : '',
        osct: location?.state?.osct ? location.state.osct : '',
        spect: location?.state?.spect ? location.state.spect : 0,
        dist: location?.state?.dist ? location.state.dist : 0,
        near: location?.state?.near ? location.state.near : 0,
        sv: location?.state?.sv ? location.state.sv : 0,
        protective_eyewear: location?.state?.protective_eyewear ? location.state.protective_eyewear : 0,
        contact_lenses_rx: location?.state?.contact_lenses_rx ? location.state.contact_lenses_rx : 0,
        bifocals: location?.state?.bifocals ? location.state.bifocals : 0,
        transitions: location?.state?.transitions ? location.state.transitions : 0,
        progressive: location?.state?.progressive ? location.state.progressive : 0,
    })

    // function formatDate(dateObj) {

    //     if (dateObj.getMonth() < 10) {
    //         const month = "0" + dateObj.getMonth();
    //         if (dateObj.getDate() < 10) {
    //             const dat = "0" + dateObj.getDate();
    //             let date = dateObj.getFullYear() + "-" + month + "-" + dat;
    //             return date
    //             // props.onValueChange(date);
    //         }
    //         else {
    //             let date = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate()
    //             return date
    //             // props.onValueChange(date);
    //         }
    //     }
    //     else {
    //         if (dateObj.getDate() < 10) {
    //             const dat = "0" + dateObj.getDate()
    //             let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
    //             return date
    //             // props.onValueChange(date);
    //         }
    //         else {
    //             let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dateObj.getDate()
    //             return date
    //             // props.onValueChange(date);
    //         }

    //     }
    // }


    function addPresc() {

        setLoading(true)
        console.log('pData = ')
        // console.log(pData)

        apiRequest(pData, 'editpresc')
            .then(data => {
                console.log(data)
                setLoading(false)
                // console.log(data)
                if (data.status == '1') {
                    // alert('Prescription Updated')
                    history.replace('/managePrescription', pData.patient_id)
                }
                else {
                    console.log('error is')
                    console.log(data.error)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }



    // useEffect(() => {
    //     getStoreCustomers()
    // }, [])



    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Edit Prescription</h1>
                                            </div>

                                            <div className="row">




                                                <Form style={{ marginTop: 20 }} >
                                                    <Form.Select
                                                        className="col-sm-6 mb-3 mb-sm-0" size="md"
                                                        disabled={true}
                                                        onChange={(v) => {
                                                            setPData({
                                                                ...pData,
                                                                cust_id: v.target.value
                                                            })
                                                        }}
                                                    >

                                                        <option selected>{location.state.cust_fname} {location.state.cust_lname} </option>


                                                      
                                                    </Form.Select>
                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >H-Phone</div>
                                                            <Form.Control
                                                                // type="password"
                                                                disabled={true}
                                                                value={pData.h_phone}
                                                                placeholder="H-Phone"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        h_phone: v.target.value
                                                                    })
                                                                }}

                                                            />
                                                        </div>
                                                        <div className="col-sm-6">

                                                            <div className="editDetails" >C-Phone</div>
                                                            <Form.Control
                                                                disabled={true}
                                                                value={pData.o_phone}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        o_phone: v.target.value
                                                                    })
                                                                }}
                                                                placeholder="C-Phone" />
                                                        </div>
                                                    </div>

                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">

                                                            <div className="editDetails" >Prescriber</div>
                                                            <Form.Control
                                                                // type="email"
                                                                value={pData.prescriber}
                                                                placeholder="Prescriber"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        prescriber: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6">

                                                            <div className="editDetails" >Prescription Date</div>
                                                            <DatePicker
                                                                style={{ margin: 0 }}
                                                                value={pData.prescription_date}
                                                                className="form-control"
                                                                selected={selectedDate}
                                                                onSelect={(v) => {
                                                                    console.log('v = ' + v)
                                                                    console.log(v)

                                                                }}
                                                                onChange={(date) => {
                                                                    // console.log(date)
                                                                    setSelectedDate(date)
                                                                    // console.log('date = ' +  formatDate(date))
                                                                    setPData({
                                                                        ...pData,
                                                                        prescription_date: date
                                                                        // formatDate(date)
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>



                                                    <Container className="mt-4" >
                                                        <Row>
                                                            <Col className="editDetails" ></Col>
                                                            <Col className="editDetails" >Sph</Col>
                                                            <Col className="editDetails" >Cyl</Col>
                                                            <Col className="editDetails" >Axis</Col>
                                                            <Col className="editDetails" >Prism</Col>
                                                            <Col className="editDetails" >TSC</Col>
                                                            <Col className="editDetails" >Dia</Col>
                                                        </Row>

                                                        <Row className="border-bottom border-secondary"  >
                                                            <Col className="editDetails" style={{ fontSize: 20 }} >OD</Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odsph}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Sph"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odsph: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odcyl}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Cyl"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odcyl: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odaxis}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Axis"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odaxis: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odprism}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Prism"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odprism: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odfi}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="TSC"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odfi: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <Form.Control
                                                                    value={pData.odct}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Dia"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odct: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="border-bottom border-secondary mt-2 " >
                                                            <Col className="editDetails" style={{ fontSize: 20 }} >OS</Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.ossph}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Sph"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            ossph: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.oscyl}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Cyl"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            oscyl: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.osaxis}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Axis"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osaxis: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.osprism}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Prism"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osprism: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.osfi}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="TSC"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osfi: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <Form.Control
                                                                    value={pData.osct}
                                                                    className="col-sm-7 mt-2"
                                                                    placeholder="Dia"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osct: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Container >






                                                    <div class="row mt-5 mb-3 pl-4 ">
                                                        <Form.Group className="col-sm-1" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.sv == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        sv: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="SV" className="check-box" />
                                                        </Form.Group>
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.protective_eyewear == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        protective_eyewear: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="PROTECTIVE EYEWER" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.contact_lenses_rx == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        contact_lenses_rx: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="CONTACT LENSES RX" className="check-box" />
                                                        </Form.Group>
                                                        {/* </div>
                                                    <div class="row mt-2 mb-3 "> */}
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.bifocals == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        bifocals: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="BIFOCALS" className="check-box" />
                                                        </Form.Group>
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.transitions == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        transitions: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="TRANSITIONS" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.progressive == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        progressive: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="PROGRESSIVE" className="check-box" />
                                                        </Form.Group>
                                                    </div>

                                                    {/* <Button variant="primary" type="submit">
                                                        Save
                                                    </Button> */}
                                                </Form>


                                                <Button
                                                    id="add_customer"
                                                    className="btn btn-primary btn-user btn-block"
                                                    onClick={() => addPresc()}
                                                    style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                >Save</Button>
                                                {/* </form> */}
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}
                            <a className="scroll-to-top rounded" href="#page-top">
                                <i className="fas fa-angle-up" />
                            </a>
                            {/* Logout Modal*/}
                            <div
                                className="modal fade"
                                id="logoutModal"
                                tabIndex={-1}
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Ready to Leave?
                                            </h5>
                                            <button
                                                className="close"
                                                type="button"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Select "Logout" below if you are ready to end your current session.
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                data-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <a className="btn btn-primary" href="logout.php">
                                                Logout
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditPrescription



{/* <div class="row mb-3 ">
<div className="col-sm-6 mt-3">
    <h3 style={{ color: 'grey' }} >OD</h3>

    <div className="editDetails mt-2 " >Sph</div>
    <Form.Control
        value={pData.odsph}
        className="col-sm-7 mt-2"
        placeholder="Sph"
        onChange={(v) => {
            setPData({
                ...pData,
                odsph: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Cyl</div>
    <Form.Control
        value={pData.odcyl}
        className="col-sm-7 mt-2"
        placeholder="Cyl"
        onChange={(v) => {
            setPData({
                ...pData,
                odcyl: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2 " >Axis</div>
    <Form.Control
        value={pData.odaxis}
        className="col-sm-7 mt-2"
        placeholder="Axis"
        onChange={(v) => {
            setPData({
                ...pData,
                odaxis: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Prism</div>
    <Form.Control
        value={pData.odprism}
        className="col-sm-7 mt-2"
        placeholder="Prism"
        onChange={(v) => {
            setPData({
                ...pData,
                odprism: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Fi</div>
    <Form.Control
        value={pData.odfi}
        className="col-sm-7 mt-2"
        placeholder="Fi"
        onChange={(v) => {
            setPData({
                ...pData,
                odfi: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Ct</div>
    <Form.Control
        value={pData.odct}
        className="col-sm-7 mt-2"
        placeholder="Ct"
        onChange={(v) => {
            setPData({
                ...pData,
                odct: v.target.value
            })
        }}
    />
</div>
<div className="col-sm-6 mt-3 ">
    <h3 style={{ color: 'grey' }}>OS</h3>

    <div className="editDetails mt-2" >Sph</div>
    <Form.Control
        value={pData.ossph}
        className="col-sm-7 mt-2"
        placeholder="Sph"
        onChange={(v) => {
            setPData({
                ...pData,
                ossph: v.target.value
            })
        }}
    />
    <div className="editDetails mt-2" >Cyl</div>
    <Form.Control
        value={pData.oscyl}
        className="col-sm-7 mt-2"
        placeholder="Cyl"
        onChange={(v) => {
            setPData({
                ...pData,
                oscyl: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Axis</div>
    <Form.Control
        value={pData.osaxis}
        className="col-sm-7 mt-2"
        placeholder="Axis"
        onChange={(v) => {
            setPData({
                ...pData,
                osaxis: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Prism</div>
    <Form.Control
        value={pData.osprism}
        className="col-sm-7 mt-2"
        placeholder="Prism"
        onChange={(v) => {
            setPData({
                ...pData,
                osprism: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Fi</div>
    <Form.Control
        value={pData.osfi}
        className="col-sm-7 mt-2"
        placeholder="Fi"
        onChange={(v) => {
            setPData({
                ...pData,
                osfi: v.target.value
            })
        }}
    />

    <div className="editDetails mt-2" >Ct</div>
    <Form.Control
        value={pData.osct}
        className="col-sm-7 mt-2"
        placeholder="Ct"
        onChange={(v) => {
            setPData({
                ...pData,
                osct: v.target.value
            })
        }}
    />
</div>
</div>
<div class="row mt-2 mb-3 ">
<Form.Group
    className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.spect == '1' ? true : false}
        onChange={(v) => {
            setPData({
                ...pData,
                spect: v.target.checked == true ? '1' : '0'
            })
        }}
        type="checkbox" label="SPECTACLES" className="check-box" />
</Form.Group>

<Form.Group className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.dist == '1' ? true : false}
        onChange={(v) => {
            setPData({
                ...pData,
                dist: v.target.checked == true ? '1' : '0'
            })
        }}
        type="checkbox" label="DISTANCE" className="check-box" />
</Form.Group>
<Form.Group className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.near == '1' ? true : false}
        onChange={(v) => {
            setPData({
                ...pData,
                near: v.target.checked == true ? '1' : '0'
            })
        }}
        type="checkbox" label="NEAR" className="check-box" />
</Form.Group>
</div> */}
